import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaShieldAlt, FaLock, FaUserShield, FaDatabase, FaCheckCircle } from 'react-icons/fa';
import './Privacy.css';

const Privacy = () => {
  const { t } = useTranslation();

  return (
    <div className="privacy-page">
      {/* Header Section */}
      <section className="privacy-header">
        <div className="privacy-header-overlay"></div>
        <div className="container">
          <h1><FaShieldAlt /> {t('privacy.title')}</h1>
          <p>{t('privacy.subtitle')}</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="privacy-content">
        <div className="privacy-container">
          {/* 1. Introduction */}
          <div className="privacy-section">
            <h2><FaUserShield /> 1. {t('privacy.intro.title')}</h2>
            <p>{t('privacy.intro.content')}</p>
          </div>

          {/* 2. Data Controller */}
          <div className="privacy-section">
            <h2>2. {t('privacy.controller.title')}</h2>
            <div className="privacy-info-box">
              <strong>{t('privacy.controller.company')}</strong>
              <p style={{ whiteSpace: 'pre-line' }}>{t('privacy.controller.address')}</p>
              <p>{t('privacy.controller.phone')}</p>
              <p>{t('privacy.controller.email')}</p>
            </div>
            <p style={{ marginTop: '1rem' }}>{t('privacy.controller.description')}</p>
          </div>

          {/* 3. Data Collection */}
          <div className="privacy-section">
            <h2><FaDatabase /> 3. {t('privacy.dataCollection.title')}</h2>
            <h3>{t('privacy.dataCollection.subtitle')}</h3>
            <p>{t('privacy.dataCollection.content')}</p>
            <ul>
              {t('privacy.dataCollection.items', { returnObjects: true }).map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            <p><em>{t('privacy.dataCollection.note')}</em></p>
          </div>

          {/* 4. Contact */}
          <div className="privacy-section">
            <h2>4. {t('privacy.contact.title')}</h2>
            <p>{t('privacy.contact.content')}</p>
          </div>

          {/* 5. Rights */}
          <div className="privacy-section">
            <h2><FaCheckCircle /> 5. {t('privacy.rights.title')}</h2>
            <p>{t('privacy.rights.content')}</p>
            <ul>
              {t('privacy.rights.items', { returnObjects: true }).map((right, index) => (
                <li key={index}>{right}</li>
              ))}
            </ul>
            <p style={{ marginTop: '1rem' }}><em>{t('privacy.rights.complaint')}</em></p>
          </div>

          {/* 6. SSL Encryption */}
          <div className="privacy-section">
            <h2><FaLock /> 6. {t('privacy.ssl.title')}</h2>
            <p>{t('privacy.ssl.content')}</p>
          </div>

          {/* 7. Hosting */}
          <div className="privacy-section">
            <h2>7. {t('privacy.hosting.title')}</h2>
            <p>{t('privacy.hosting.content')}</p>
            <p style={{ marginTop: '1rem' }}><em>{t('privacy.hosting.legal')}</em></p>
          </div>

          {/* 8. Changes */}
          <div className="privacy-section">
            <h2>8. {t('privacy.changes.title')}</h2>
            <p>{t('privacy.changes.content')}</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Privacy;

